import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { DataService } from './../../../../admin/system-log-manager/data.service';
import { Location } from '@angular/common';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';


@Component({
  selector: 'app-system-document-type-affidavits',
  templateUrl: './system-document-type-affidavits.component.html',
  styleUrls: ['./system-document-type-affidavits.component.css'],
  providers: [DataService, ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class SystemDocumentTypeAffidavitsComponent implements OnInit {

 // for grid so it has change events.
 public data: Observable<DataStateChangeEventArgs>;
 public state: DataStateChangeEventArgs;
 @ViewChild('grid')
 public grid: GridComponent;

 public pageSettings: Object;
 public pageOptions = { pageSize: 100 }; 
 public filterOptions: FilterSettingsModel;
 public formatOptions: any;
 // public filterOptions: FilterSettingsModel;
 public filter : IFilter;
 public toolbarOptions: ToolbarItems[] | object;
 public groupOptions: GroupSettingsModel;
 public templateOptionsDate: IFilterUI;
 public elem1: HTMLElement;
 public datePickerObj: DatePicker;
 initialPage: { pageSize: number; };
 dateFormat: string;

  job_type_locations: any;

  currentUserVAR: any;
  nav: any;
  sessionUserId: any;
  sessionBrandId: any;
  job_type_courts: Object;
  job_type_court_id: number;
  job_type_location_id: number;
  job_type_document_types: Object;
  job_type_document_type_id: number;
  job_type_affidavit_types: Object;
  modalRef: any;
  initialCount = 0; // Put this in the master -> for child component
  public count;
  job_type_affidavit_types_grid: Object;
  send_job_type_id: any;
  send_job_type_document_type_id: number;
  send_job_type_court_id: number;
  send_job_type_location_id: number;
  send_job_type_affidavit_type_name: any;
  job_type_court_name: any;
  job_type_document_type_name: any;
  job_type_location_name: any;
  job: Object;
  job_type_name: any;
  job_type: Object;
  job_type_id: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService
  ) {

    this.nav = document.querySelector('nav.navbar');

  // login vars
  this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  console.log('sessionUserId: ', this.currentUserVAR.user_id );
  console.log('sessionUsername: ', this.currentUserVAR.username );
  // Set loggind in User Value (USER ID)
  this.sessionUserId = this.currentUserVAR.user_id;
  this.sessionUserId = this.currentUserVAR.username;
  this.sessionBrandId = this.currentUserVAR.brand_id;

  this.job_type_document_type_id = +this.route.snapshot.paramMap.get('job_type_document_type_id') as number;
  console.log('job_type_document_type_id: ', this.job_type_document_type_id)
   }

  ngOnInit() {

    this.getJobTypeAffidavitTypes(this.job_type_document_type_id);
    this.getJobTypeAffidavitTypesGrid(this.job_type_document_type_id);
   
    // Setup Grid
this.toolbarOptions = ['ExcelExport', 'Search'
];
// this.toolbar = [
// { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

//  this.initialPage = { pageSize: 100 };
this.filterOptions = {
  type: 'Menu'
};
this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
this.dateFormat = 'dd/MM/yyyy hh:mm a';
this.filter = { params: { format: this.dateFormat } };
// end grid setup
  }

  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypesGrid(job_type_document_type_id).subscribe(
       data => { 
        this.job_type_affidavit_types = data;
        let res = data[0];
       this.getJobTypeDocument(this.job_type_document_type_id);
        // this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeCourt(res.job_type_court_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobType(res.job_type_id);
        // set all the master vars 
        this.job_type_id = res.job_type_id;
        this.job_type_court_id = res.job_type_court_id;
        this.job_type_location_id = res.job_type_location_id;
       
      //  
     
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   };

// Navigation Breadcrumbs
   getJobTypeDocument(job_type_document_type_id){
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
      data => { 
       this.job_type_document_types = data;
       let res = data[0];

       this.getJobTypeCourt(res.job_type_court_id);
       this.getJobTypeLocation(res.job_type_location_id);
       this.getJobType(res.job_type_id);
       // set all the master vars 
       this.job_type_id = res.job_type_id;
       this.job_type_court_id = res.job_type_court_id;
       this.job_type_location_id = res.job_type_location_id;



       this.job_type_document_type_name  = res.job_type_document_type_name; 

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
   }


// getJobTypeDocumentTypes(job_type_court_id) {
//   this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
//      data => { 
//       this.job_type_document_types = data;
//       let res = data[0];
//       this.job_type_document_type_name  = res.job_type_document_type_name; 
//        this.job_type_document_type_id = res.job_type_document_type_id;
//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  };

getJobTypeCourt(job_type_court_id){
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
    data => { 
      this.job_type_courts = data;
      let res = data[0];
      this.job_type_court_name = res.job_type_court_name;
     },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


//  getJobTypeCourts(job_type_location_id) {
//   this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
//      data => { 
//        this.job_type_courts = data;
//        let res = data[0];
//        this.job_type_court_name = res.job_type_court_name;
       
//       },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }


 getJobTypeLocation(job_type_location_id){
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
    data => { this.job_type_locations = data;
   let res = data[0];
   this.job_type_location_name = res.job_type_location_name;

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }



//  getJobTypeLocations(job_type_id) {
//   this._demoService.getJobTypeLocations(job_type_id).subscribe(
//      data => { this.job_type_locations = data;
//       let res = data[0];
//       this.job_type_location_name = res.job_type_location_name;
//     },
//      err => console.error(err),
//      // () => console.log('done loading Trace Types')
//    );
//  }

 getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { this.job_type = data;
      let res = data[0];
this.job_type_name = res.job_type_name;
this.job_type_id = res.job_type_id;
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

   getJobTypeAffidavitTypesGrid(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypesGrid(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types_grid = data;
       // console.log('Grid: ' + this.job_type_affidavit_types_grid);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.job_type_locations }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}

// MODAL
// start of modal windows service as a template
// openModal(template: TemplateRef<any>) {
//   // small upgrade to disable background click on open modal background
//   const config = { backdrop: true, ignoreBackdropClick: true };
//   this.modalRef = this.modalService.show(template, config);
// }

openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

sendTypeID(id, job_type_id, job_type_document_type_id, job_type_court_id, job_type_location_id, job_type_affidavit_type_name) {
  this.count = id;  // actually job_type_affidavit_type_id
  this.initialCount = id;
  this.send_job_type_id = job_type_id;
  this.send_job_type_document_type_id = job_type_document_type_id;
  this.send_job_type_court_id = job_type_court_id;
  this.send_job_type_location_id = job_type_location_id;
  this.send_job_type_affidavit_type_name = job_type_affidavit_type_name;


// console.log('sending ID:' + this.count);

}



refreshGrid() { // refresh the databutton
  // this.getFiles();
  this.getJobTypeAffidavitTypes(this.job_type_document_type_id);
  this.grid.refresh();
};
   // to router navigate back
   public goBack() {
    this._location.back();
    }

    viewDocumentTypeAffidavits(job_type_affidavit_type_id){
  this.router.navigate(['/admin/system-settings/job-types/locations/courts/document-types/affidavits/' + job_type_affidavit_type_id + '']);
}

viewSubjectDocTemplate(doc_id){
  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
}
// blanc canvus
createSubjectDocTemplate(doc_id){
  this.router.navigate(['admin/communication/com_type_template_doc_create/4']);
}
editDocxTemplate(doc_id){
  this.router.navigate(['admin/communication/template_doc_view/template/' + doc_id]);
}

docEditTemplateFile(doc_id) {
  this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
}

docViewTemplateFile(doc_id) {
  this.router.navigate(['/admin/communication/template_doc_view/template-view/' + doc_id + '']);
}


deleteSubjectTemplateDoc(doc_id) {
  if (confirm('Are you sure you want to delete this communication template. It cannot be undone!? ')) {
  this._demoService.deleteSubjectTemplateDoc(doc_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    this.toastr.success('Subject Communication template Removed. We have left all docx and themes original files on the server');
    //  this.getSubjectAgentAssigned(subject_id);
   // this.gfunc.globalSystemSubjectTemplateDocsSkipRoute(this.subject_com_type_id);
      //  return true;
      this.refreshGrid();
     },
     error => {
       console.error('Error removing communication template!');
       return error(error.error);
     }
  );
  
}// end if
} ;





}